import { gql } from "@apollo/client";

export const GET_INDICACIONES_BY_PANTALLA = gql`
    query IndicacionesRIByIdPantallaRI (
        $idPantallaRI: Int!
        $idDatosGeneralesRI: Int!
    ) {
        indicacionesRIByIdPantallaRI (
            idPantallaRI: $idPantallaRI
            idDatosGenerales: $idDatosGeneralesRI
        ){
            idIndicacionRI
            idInsumo
            idInsumoNavigation{
                presentacion
                presentacionGenerica
                descripcion
                idUnidadNavigation{
                    alias
                }
            }
            cantidadDiaria
        }
    }
`;